import React from 'react';
import { ATMField, ATMForm, ATMGrid, ATMInput } from 'shared-it-appmod-ui';
import Lang from 'src/libraries/language';
import { FireAgencyFormSchema } from 'src/models/fire-agency.model';
import style from '../fire-agencies-list/fire-agencies-list.module.scss';

type IProp = {
  formRef: React.RefObject<HTMLFormElement>;
  defaultValues: any;
  handleSubmit: (data) => void;
  handleEnable: (value) => void;
};

const FireAgenciesForm: React.FC<IProp> = ({
  formRef,
  defaultValues = {},
  handleSubmit,
  handleEnable,
}) => {
  return (
    <div className="form-container">
      <ATMForm
        ref={formRef}
        onSubmit={handleSubmit}
        mode="onChange"
        defaultValues={defaultValues}
        validationSchema={FireAgencyFormSchema}
      >
        {({ control, errors, formState }) => {
          handleEnable(formState.isDirty);

          return (
            <ATMGrid>
              <ATMGrid.Row columns="equal">
                <ATMGrid.Column>
                  <ATMField
                    label={Lang.LBL_AGENCY_NAME}
                    name="name"
                    control={control}
                    as={ATMInput}
                    placeholder={Lang.LBL_ENTER}
                    required
                    error={errors.name}
                  />
                  <ATMField
                    as={ATMInput}
                    type="hidden"
                    name="agencyId"
                    control={control}
                    error={errors.agencyId}
                  />
                </ATMGrid.Column>
                <ATMGrid.Column>
                  <label className={style.label}>{Lang.LBL_USD}</label>
                  <ATMField
                    label={Lang.LBL_AGENCY_RATE}
                    name="rate"
                    control={control}
                    as={ATMInput}
                    type="number"
                    min={0}
                    max={99999}
                    placeholder={Lang.LBL_ENTER}
                    required
                    error={errors.rate}
                  />
                </ATMGrid.Column>
              </ATMGrid.Row>
            </ATMGrid>
          );
        }}
      </ATMForm>
    </div>
  );
};

export default FireAgenciesForm;
